





import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DeleteIcon from '@mui/icons-material/Delete';

import Navbar from './Navbar';
import BrandHeader from './BrandHeader';

const RaiseComplaint = () => {
  const [brandData, setBrandData] = useState({});
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [complaints, setComplaints] = useState([]);
const navigate = useNavigate();

  const fetchComplaints = async (brandId) => {
    try {
      const complaintsRes = await fetch(`https://server-side-influencer.onrender.com/brand/mycomplaints/${brandId}`);
      const complaintsData = await complaintsRes.json();
      if (complaintsData.success) {
        setComplaints(complaintsData.data);
      }
    } catch (err) {
      console.error("Failed to fetch complaints:", err);
      toast.error("Failed to fetch complaints");
    }
  };

  useEffect(() => {
    const fetchBrandData = async () => {
      try {
        const brandId = localStorage.getItem("brandID");
        if (!brandId) {
          console.log("Brand ID not found in localStorage");
          return;
        }

        const response = await fetch(`https://server-side-influencer.onrender.com/brand/getBrandData/${brandId}`);
        const data = await response.json();
        setBrandData(data.data);

        fetchComplaints(brandId);
      } catch (err) {
        console.error("Failed to fetch brand data or complaints:", err);
        toast.error("Failed to load brand data or complaints");
      }
    };

    fetchBrandData();
  }, []);

  const handleDelete = async (id) => {
    try {
      await fetch( `https://server-side-influencer.onrender.com/brand/deletemycomplaint/${id}`, {
        method: 'DELETE',
      });

      const brandId = localStorage.getItem("brandID");
      if (brandId) {
        await fetchComplaints(brandId);
      }

      toast.success("Complaint deleted successfully!");
    } catch (err) {
      console.error("Error deleting complaint:", err);
      toast.error("Failed to delete complaint");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      brandName: brandData?.shopName,
      brandEmail: brandData?.email,
      subject,
      message,
    };

    try {
      const brandId = localStorage.getItem("brandID");
      const res = await fetch(`https://server-side-influencer.onrender.com/brand/complaint/${brandId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (!res.ok || !result.success) {
        throw new Error(result.message || 'Submission failed');
      }

      toast.success("Your complaint submitted successfully!");
      setSubject('');
      setMessage('');
      fetchComplaints(brandId);
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Something went wrong while submitting.");
    }
  };

  return (
  
  <div className="flex h-auto min-h-screen w-full bg-white">
    {/* Navbar */}
    <div className="fixed top-0 left-0 bottom-0 text-white z-50">
      <Navbar />
    </div>

    {/* Main Content */}
    <div className="flex flex-col flex-1 ml-10 mb-10">
      <div className="z-40">
        <BrandHeader page="Raise Complaint" />
      </div>

      {/* Top Right Button */}
      <div className="flex justify-end items-center mt-4 mr-10">
        <button
          type="button"
          className="mt-12 text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
  onClick={() => navigate('/brandsumitted')}
        >
          Submitted Complaints
        </button>
      </div>

      {/* Complaint Form */}
      <div className="flex justify-center mt-6">
        <h2 className="text-3xl font-semibold text-center">Register your complaint here</h2>
      </div>

      <div className="flex justify-center items-center flex-1 mt-1">
        <div className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-2xl">
          <form onSubmit={handleSubmit}>
            <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="subject">
              Subject
            </label>
            <input
              type="text"
              id="subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="w-full p-3 mb-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter subject"
              required
            />

            <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="message">
              Message
            </label>
            <textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full h-40 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Write your complaint here..."
              required
            />

            <button
              type="submit"
              className="mt-4 w-full text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-2 flex justify-center items-center"
            >
              Submit
            </button>
          </form>
        </div>
      </div>

      {/* Toast Notifications */}
      <ToastContainer position="bottom-right" autoClose={3000} />
    </div>
  </div>
);

};

export default RaiseComplaint;
